import React from 'react'

import './index.less'

export const Header = () => (
  <header id='header'>
    <img
      id='img-logo'
      src='https://gcmgames-static.s3.amazonaws.com/img/logo.png'
      alt='GCM Games'
    />
  </header>
)
